import { useSnackbar } from "notistack";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    const timer = setTimeout(() => {
          enqueueSnackbar("Page not found. Redirecting to your login", { variant: "error" });
      navigate("/");
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate, enqueueSnackbar]);

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 text-center p-4">
      <h1 className="text-5xl font-bold text-red-600 mb-4">404</h1>
      <p className="text-xl text-gray-700 mb-2">Oops! Page not found.</p>
      <p className="text-gray-500 mb-6">
        You have entered a wrong URL. Redirecting you to login...
      </p>
      <div className="animate-pulse text-blue-500">Redirecting...</div>
    </div>
  );
};

export default NotFound;
    
  